import { useEffect } from "react";

/** Inline inbox dialogs consume Escape before background navigation. */
export function useInboxDialogEscape(open: boolean, close: () => void, busy = false) {
  useEffect(() => {
    if (!open) return;
    function escape(event: KeyboardEvent) {
      if (event.key !== "Escape" || document.querySelector("dialog[open], .inbox-split-modal")) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (!busy) close();
    }
    window.addEventListener("keydown", escape, true);
    return () => window.removeEventListener("keydown", escape, true);
  }, [open, close, busy]);
}
